<span>{{remainingTimeString$ | async}}</span>
